import { isNotUndefined } from "@faire/typescript";
import { compareDesc } from "date-fns/compareDesc";

export const getLatestDataUpdatedAt = (
  allDataUpdatedAt: (number | undefined)[]
): number => {
  return allDataUpdatedAt.filter(isNotUndefined).sort(compareDesc)[0] as number;
};
